var Thumbnail = require('./Thumbnail');

module.exports = Thumbnail;
